import React from "react";

import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const SessionBuildTable = ({
  rows,
  statusByRow,
  isGenerating,
  rowKey,
  hasChanged,
  onGenerate,
  onShowDescription,
  defaultDescription,
}) => (
  <Box sx={{ position: "relative" }}>
    <TableContainer
      component={Paper}
      className="step7-table"
    >
      <Table
        size="small"
        className="step7-table-inner"
      >
        <TableHead className="step7-thead">
          <TableRow>
            <TableCell
              className="step7-th step7-th-nro"
            >
              N° Sesión
            </TableCell>

            <TableCell
              className="step7-th step7-th-tema"
            >
              Sesión de Aprendizaje
            </TableCell>

            <TableCell
              className="step7-th step7-th-desc"
            >
              Descripción
            </TableCell>

            <TableCell
              className="step7-th step7-th-actions"
              align="center"
            >
              Acciones
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row) => {
            const saved =
              statusByRow[rowKey(row)];

            const changed =
              hasChanged(
                row,
                saved?.snapshot
              );

            return (
              <TableRow
                key={rowKey(row)}
                className="step7-tr"
              >
                <TableCell
                  className="step7-td step7-td-nro"
                >
                  Sesión {row.nroSesion}
                </TableCell>

                <TableCell
                  className="step7-td step7-td-tema"
                >
                  {row.tema}
                </TableCell>

                <TableCell
                  className="step7-td step7-td-desc"
                >
                  <Typography
                    className="step7-desc-preview"
                  >
                    {row.descripcion ||
                      defaultDescription}
                  </Typography>

                  {row.descripcion?.length >
                    180 && (
                    <Button
                      size="small"
                      sx={{
                        mt: 0.5,
                        px: 0,
                        minWidth: "auto",
                        fontSize: 11,
                      }}
                      onClick={() =>
                        onShowDescription(
                          row
                        )
                      }
                    >
                      Ver más
                    </Button>
                  )}
                </TableCell>

                <TableCell
                  className="step7-td step7-td-actions"
                >
                  <Box
                    className="step7-actions-wrapper"
                    align="center"
                  >
                    <Button
                      size="small"
                      disabled={isGenerating}
                      onClick={() =>
                        onGenerate(row)
                      }
                      className="step7-action-inline"
                    >
                      {saved && !changed
                        ? "Ver"
                        : "Generar sesión"}
                    </Button>
                  </Box>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  </Box>
);

export default SessionBuildTable;